import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  SENDOTP_INIT_ACTION,
  SENDOTP_SUCCESS_ACTION,
  SENDOTP_FAIL_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import { push } from "connected-react-router";
import "react-toastify/dist/ReactToastify.css";

function* sendOTP() {
  try {
    const token = localStorage.getItem("token");
    const data = { ok: true };
    const res = yield fetch(`${appConfig.ip}/phoneVerify/sendotp`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: SENDOTP_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("OTP Sent", {
        autoClose: 3000,
        transition:Flip
      });
      yield put(push("/verifyotp"));
    }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("User denied", {
        autoClose: 3000,
        transition:Flip
      });
    }

    yield put({
      type: SENDOTP_FAIL_ACTION,
      payload: err,
    });
  }
}

export function* OTPActionWatcher() {
  yield takeEvery(SENDOTP_INIT_ACTION, sendOTP);
}